/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import Typography from 'apollo-react/components/Typography';
import _ from 'lodash';
import qs from 'query-string';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link as RRLink, useHistory } from 'react-router-dom';

import { clearErrors } from '../../actions/ErrorActions';
import { setIdMenuModalDialog, setOpenMenuModalDialog } from '../../actions/MenuDialogActions';
import { clearWarnings } from '../../actions/WarningActions';
import LazyText from '../../components/LazyText';
import Link from '../../components/Link';
import NavigateLink from '../../components/NavigateLink';
import customMenus from '../../components/Sidenav/customMenus';
import { ENTITY_DISPLAY, SMART_INSIGHT_REPORTS_LIST, WORKFLOW_STEP } from '../../constants/Urls';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { FORMS_DESIGN_RIGHT } from '../../form-designer/constants/editor.constants';
import {
  isExternalLink,
  prependProtocol,
  preprocessUrl,
} from '../../form-designer/utils/controls/ssHyperLink.utils';
import { getAvailableNavigation } from '../../selectors/MasterSetupPageSelectors';
import { getEnvVar } from '../../utils/env';
import { getFilteredAdminNavigationLinkForMobile } from '../../utils/menuDialogUtils';

const useStyles = makeStyles({
  createContent: {
    minWidth: 300,
    minHeight: 150,
  },
  revokeContent: {
    minWidth: 300,
    minHeight: 50,
  },
  modal: {
    maxWidth: 'unset',
    minWidth: 300,
  },
  drawerSubtitle: {
    fontSize: '12px',
  },
  drawerSubgroups: {
    padding: '1rem 0rem',
  },
  drawerSubgroupTitle: {
    fontSize: 14,
    fontWeight: 600,
  },
  drawerGroup: {
    listStyle: 'none',
  },
  drawerLinkContainer: {
    lineHeight: 1.5,
    padding: '0.5rem 0',
  },
  drawerLink: {
    color: '#297dfd',
    fontSize: '16px',
    fontWeight: 500,
    cursor: 'pointer',
  },
});

const MenuDialog = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const translateString = useTranslation();

  const navigation = useSelector(getAvailableNavigation, shallowEqual);
  const userRights = useSelector((state) => state.userRights);
  const auth = useSelector((state) => state.auth);
  const isOpen = useSelector((state) => state.topMenu.menuModalDialog.isOpen);
  const menuId = useSelector((state) => state.topMenu.menuModalDialog.menuId);

  const [drawer, setDrawer] = useState(null);

  const handleModalClose = () => {
    dispatch(setOpenMenuModalDialog(false));
    dispatch(setIdMenuModalDialog(null));
    setDrawer(null);
  };

  const createEntity = (
    entityViewName,
    entityType,
    formKey,
    containerWorkflowKey,
    workflowKey,
    stepId
  ) => {
    handleModalClose();

    history.push(
      `${WORKFLOW_STEP}?${qs.stringify({
        containerWorkflowKey,
        workflowKey,
        stepId,
        entityViewName,
        entityType,
      })}`
    );
  };

  const renderGroupLink = (link) => {
    if (link.ID === 'NewWorkflowDesigner') {
      return (
        <NavigateLink
          className={classes.drawerLink}
          onClick={handleModalClose}
          to={getEnvVar('WORKFLOW_DESIGNER_APP_URL')}
          target="_blank"
        >
          {link.Text}
        </NavigateLink>
      );
    }

    if (link.ID === 'R2TDesigner') {
      const userFullName = localStorage.getItem('userFullName');
      const preprocessedUrl = `${getEnvVar('R2T_DESIGNER_APP_URL')}?token=${
        auth.token
      }&userFullName=${userFullName}`;
      return (
        <NavigateLink
          className={classes.drawerLink}
          onClick={handleModalClose}
          to={preprocessedUrl}
          target="_blank"
        >
          {link.Text}
        </NavigateLink>
      );
    }

    if (link.Type === 'BulkEdit') {
      const { FormName } = link.NavigateURL ? qs.parse(link.NavigateURL.split('?')[1]) : {};

      return (
        <RRLink
          className={classes.drawerLink}
          onClick={handleModalClose}
          to={{
            pathname: '/bulk-edit',
            search: qs.stringify({
              entityType: link.EntityName,
              formKey: FormName,
            }),
          }}
        >
          {link.Text}
        </RRLink>
      );
    }

    if (link.ID === 'SmartInsightReports') {
      return (
        <RRLink
          className={classes.drawerLink}
          onClick={handleModalClose}
          to={SMART_INSIGHT_REPORTS_LIST}
        >
          {link.Text}
        </RRLink>
      );
    }

    if (link.NavigateURL?.includes('.aspx')) {
      const preprocessedUrl = preprocessUrl(link.NavigateURL, auth.token);

      return (
        <NavigateLink
          className={classes.drawerLink}
          to={preprocessedUrl.join('?')}
          target="_blank"
          onClick={handleModalClose}
        >
          {link.Text}
        </NavigateLink>
      );
    }

    if (link.Type === 'EntitySearch') {
      return (
        <RRLink
          className={classes.drawerLink}
          onClick={handleModalClose}
          to={{
            pathname: '/find',
            search: qs.stringify({ entityName: link.EntityName, searchName: link.SavedSearchName }),
          }}
        >
          {link.Text}
        </RRLink>
      );
    }

    const masterSetupTypes = [
      'MasterSetupSearch',
      'MasterSetupSearchDisableAdd',
      'MasterSetupDisableBulkImport',
      'MasterSetupOptimizedSearch',
      'MasterSetupOptimizedSearchDisableAdd',
      'MasterSetupOptimizedSearchDisableBulkImport',
    ];

    if (masterSetupTypes.includes(link.Type)) {
      return (
        <RRLink
          className={classes.drawerLink}
          onClick={handleModalClose}
          to={{
            pathname: '/master-setup',
            search: qs.stringify({
              entityName: link.EntityName,
              searchName: link.SavedSearchName,
            }),
          }}
        >
          {link.Text}
        </RRLink>
      );
    }

    if (link.Type === 'ModuleUpgrade') {
      const pathname = '/upgrade-modules';
      return (
        <RRLink className={classes.drawerLink} onClick={handleModalClose} to={pathname}>
          {link.Text}
        </RRLink>
      );
    }

    if (link.ID === 'FormsEditor' || link.ID === 'EntityEditor') {
      return (
        <RRLink
          className={classes.drawerLink}
          onClick={handleModalClose}
          to={link.NavigateURL}
          target="_blank"
        >
          {link.Text}
        </RRLink>
      );
    }

    if (link.Type === 'CacheList') {
      return (
        <RRLink className={classes.drawerLink} onClick={handleModalClose} to={link.NavigateURL}>
          {link.Text}
        </RRLink>
      );
    }

    const workflowMasterSetupTypes = [
      'WorkflowBasedMasterSetupSearch',
      'WorkflowBasedMasterSetupSearchDisableAdd',
      'WorkflowBasedMasterSetupSearchDisableBulkImport',
    ];

    if (workflowMasterSetupTypes.includes(link.Type)) {
      return (
        <RRLink
          className={classes.drawerLink}
          onClick={handleModalClose}
          to={{
            pathname: '/workflow-master-setup',
            search: qs.stringify({
              containerWorkflowKey: link.ContainerWorkflowKey,
              entityName: link.EntityName,
              entityViewName: link.ViewName,
              searchName: link.SavedSearchName,
              stepId: link.StepId,
              workflowKey: link.WorkflowKey,
            }),
          }}
        >
          {link.Text}
        </RRLink>
      );
    }

    if (drawer.Title === 'Recent') {
      return (
        <Link
          className={classes.drawerLink}
          onClick={handleModalClose}
          to={{
            pathname: ENTITY_DISPLAY,
            search: qs.stringify({
              entityType: link.EntityName,
              formKey: link.FormKey,
              itmId: link.ItmId,
            }),
          }}
        >
          {link.Text}
        </Link>
      );
    }

    if (isExternalLink(link.NavigateURL)) {
      return (
        <NavigateLink
          className={classes.drawerLink}
          onClick={handleModalClose}
          to={prependProtocol(link.NavigateURL)}
          target="_blank"
        >
          {link.Text}
        </NavigateLink>
      );
    }

    return (
      <a
        className={classes.drawerLink}
        onClick={() => {
          handleModalClose();
          dispatch(clearWarnings());
          dispatch(clearErrors());

          createEntity(
            link.ViewName,
            link.EntityName,
            link.FormKey,
            link.ContainerWorkflowKey,
            link.WorkflowKey,
            link.StepId
          );
        }}
      >
        {link.Text}
      </a>
    );
  };

  useEffect(() => {
    if (menuId && isOpen) {
      const customMenu = customMenus?.find((cm) => cm?.config?.id === menuId);

      const menuItem = navigation?.find((i) => i.Id === menuId);

      let contentData = _.isNil(customMenu)
        ? menuItem.contentInfos?.menu?.contentData
        : customMenu?.config?.contentInfos?.menu?.contentData;

      if (menuId === 'ModuleAdminMenu') {
        contentData = getFilteredAdminNavigationLinkForMobile(contentData);
      }

      setDrawer({ ...contentData, Id: menuId });
    }
  }, [isOpen, menuId, navigation]);

  return (
    <Modal
      hideButtons
      className={classes.modal}
      disableBackdropClick
      disableEscapeKeyDown
      disablePortal
      onClose={handleModalClose}
      open={isOpen}
      title={translateString(drawer?.Title)}
      PaperProps={{ style: { margin: 16, width: '100%' } }}
    >
      <div>
        <LazyText text={translateString(drawer?.SubTitle)}>
          <Typography ui-ta="action-drawer" className={classes.drawerSubtitle} variant="body2">
            {translateString(drawer?.SubTitle)}
          </Typography>
        </LazyText>

        {drawer?.Component && <drawer.Component classes={classes} closeDrawer={handleModalClose} />}

        {drawer?.templateData &&
          drawer.templateData.map((group, index) => (
            <div key={index} className={classes.drawerSubgroups}>
              <p className={classes.drawerSubgroupTitle}>{group.Text}</p>
              <ul className={classes.drawerGroup}>
                {group.Links.filter(
                  (link) =>
                    link.ID !== 'FormsEditor' ||
                    (link.ID === 'FormsEditor' && userRights.includes(FORMS_DESIGN_RIGHT))
                ).map((link) => (
                  <li key={link.ID} ui-ta={link.ID} className={classes.drawerLinkContainer}>
                    {renderGroupLink(link)}
                  </li>
                ))}
              </ul>
            </div>
          ))}
      </div>
    </Modal>
  );
};

export default MenuDialog;
